/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import v from './validators';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const dealOptions = [
  {
    label: 'najem',
    value: 'najmu',
    state: 'rodzajUmowy',
  },
  {
    label: 'dzierżawa',
    value: 'dzierżawy',
    state: 'rodzajUmowy',
  },
  {
    label: 'użyczenie',
    value: 'użyczenia',
    state: 'rodzajUmowy',
  },
];

const workOptions = [
  {
    label: 'wydzierżawienie',
    value: 'Wydzierżawiony',
    state: 'rodzajDzialania',
  },
  {
    label: 'użyczenie',
    value: 'Użyczony',
    state: 'rodzajDzialania',
  },
];

const changeDict = {
  rodzajUmowy: {
    label: 'Rodzaj umowy',
    editable: true,
    type: 'Select',
    options: dealOptions,
  },
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  rodzajDzialania: {
    label: 'Rodzaj działania',
    editable: true,
    type: 'Select',
    options: workOptions,
  },
  przeznaczenie: {
    label: 'Przeznaczenie gruntu',
    editable: true,
    type: 'textarea',
  },
};


class PrzedluzenieUmowyNieruchomosci extends React.Component {
  state = {
    info: {
      rodzajUmowy: null,
      miejscowosc: null,
      ulica: null,
      rodzajDzialania: null,
      przeznaczenie: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
  };

  validators = {
    rodzajUmowy: [v.NotSelected],
    miejscowosc: [v.NotNull],
    ulica: [v.NotNull],
    rodzajDzialania: [v.NotSelected],
    przeznaczenie: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        miejscowosc: 'Olesno',
        ulica: 'Testowa',
        przeznaczenie: 'Przeznaczenie testowe',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={changeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PrzedluzenieUmowyNieruchomosci.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(PrzedluzenieUmowyNieruchomosci),
);



// WEBPACK FOOTER //
// src/routes/eservices/PrzedluzenieUmowyNieruchomosci.js